import React from 'react';
import { ArrowLeft, ArrowRight, Check } from 'lucide-react';
import { Action, LinkButton } from '../ui';

export const RFQSteps = ({ step }) => <div className="steps">
  {['Your requirements', 'Delivery & details', 'Review & send'].map((label, index) => (
    <div key={label} className={step >= index ? 'active' : ''} data-testid={`rfq-step-${index}`}>
      <span>{step > index ? <Check size={13} /> : index + 1}</span>{label}
    </div>
  ))}
</div>;

const SubmitRequest = ({ user, busy }) => {
  if (user?.role === 'buyer' && user.approval === 'approved') {
    return <Action id="rfq-submit" type="submit" busy={busy}>Send quotation request<ArrowRight size={17} /></Action>;
  }
  return <LinkButton to={user ? '/workspace' : '/auth'} id="rfq-login-required">
    {user ? 'Business approval required' : 'Sign in to send request'}
  </LinkButton>;
};

export const RFQNavigation = ({ step, setStep, validItems, user, busy }) => (
  <div className="form-actions">
    {step > 0 && <Action secondary id="rfq-back" type="button" onClick={() => setStep(current => current - 1)}><ArrowLeft size={16} />Back</Action>}
    {step < 2 ? <Action id="rfq-next" type="submit" disabled={!validItems}>Continue<ArrowRight size={17} /></Action>
      : <SubmitRequest user={user} busy={busy} />}
  </div>
);